import { memo } from "react"

import { getPrefixedClassNames, styles } from "./styles"

import { cx } from "@emotion/css"
import { useCell } from "./data"
import { useFocusManagement } from "./FocusManager"
import { useTableContext } from "./context"

type GridCellProps = {
  rowIndex: number
  rowId: string
  columnId: string
}

export function GridCellWrapped({ rowIndex, rowId, columnId }: GridCellProps) {
  const { columnManager: cm, getCellProps, scrollingFast } = useTableContext()
  const column = cm.getColumnById(columnId)
  const columnIndex = cm.getColumnIndexById(columnId)

  const { getManagerProps } = useFocusManagement()

  if (!column) return null
  if (scrollingFast) return null

  const { width, align = "left", dataKey, Cell } = column

  const { className, ...rest } = getCellProps(rowId, dataKey)

  return (
    <div
      role="gridcell"
      data-grid-row-cell
      data-column-id={columnId}
      {...rest}
      {...getManagerProps(rowIndex, columnIndex)}
      className={cx(
        styles.cell,
        styles.bodyCell,
        styles.aligns[align],
        getPrefixedClassNames("cell", "grid-cell"),
        className,
      )}
      style={{ width }}
    >
      {Cell ? (
        <Cell
          rowIndex={rowIndex}
          rowId={rowId}
          columnIndex={columnIndex}
          columnId={columnId}
          dataKey={dataKey}
          align={align}
        />
      ) : (
        <DefaultCellRender rowId={rowId} dataKey={dataKey} />
      )}
    </div>
  )
}

export const GridCell = memo(GridCellWrapped) as typeof GridCellWrapped

export function DefaultCellRender(props: { rowId: string; dataKey: string }) {
  // @ts-ignore
  const [value] = useCell(props.rowId, props.dataKey)
  return <span className={styles.cellText}>{value || " - "}</span>
}
